// 持久化工具：默认用 localStorage，带 ?portal=xxx 参数时用 sessionStorage 隔离
const PREFIX = 'talent_retention_v3_'

function useSession() {
  return typeof window !== 'undefined' && window.location.search.includes('portal=')
}

function getStore() {
  return useSession() ? sessionStorage : localStorage
}

// 供外部直接操作原始 key（如 'role'，不带前缀）
export function rawGet(key) {
  try {
    return getStore().getItem(key)
  } catch (e) {
    return null
  }
}

export function rawSet(key, value) {
  try {
    getStore().setItem(key, value)
  } catch (e) {
    console.warn('rawSet failed', e)
  }
}

export function rawRemove(key) {
  try {
    getStore().removeItem(key)
  } catch (e) {
    console.warn('rawRemove failed', e)
  }
}

export default {
  get(key) {
    try {
      const store = getStore()
      if (key) {
        return JSON.parse(store.getItem(PREFIX + key) || 'null')
      }
      // 兼容旧数据：读取旧的聚合 key
      const legacy = JSON.parse(store.getItem('talent_retention_v3') || '{}')
      return legacy
    } catch (e) {
      return key ? undefined : {}
    }
  },

  set(key, value) {
    try {
      const store = getStore()
      store.setItem(PREFIX + key, JSON.stringify(value))
    } catch (e) {
      console.warn('storage set failed', e)
    }
  },

  remove(key) {
    try {
      const store = getStore()
      store.removeItem(PREFIX + key)
    } catch (e) {
      console.warn('storage remove failed', e)
    }
  },

  clear() {
    const store = getStore()
    Object.keys(store).forEach(k => {
      if (k.startsWith(PREFIX)) store.removeItem(k)
    })
    store.removeItem('talent_retention_v3')
  }
}
